import React from "react";
import { judgmentTerminal } from "../../components/Terminal";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import SwiperCore, {
  Mousewheel,
  Pagination,
  Virtual,
  Navigation,
  Keyboard,
  Autoplay,
} from "swiper";
// 引入HOC高阶函数withTranslation 和 i18n的ts类型定义WithTranslation
import { withTranslation, WithTranslation } from "react-i18next";
import { Player, ControlBar } from "video-react";
import Nav from "./Nav";
import About from "./About";
import Product from "./Product";
import News from "./News";
import Contact from "./Contact";
// 导入css动画效果
// import {CSSTransition} from 'react-transition-group'
import "swiper/swiper-bundle.min.css";
import "video-react/dist/video-react.css";
import "../../assets/styles/newStyle.scss";
SwiperCore.use([Mousewheel, Pagination, Navigation, Keyboard, Autoplay]);
class HomeComponent extends React.Component<WithTranslation> {
  state = {
    isMobile: false,
    mySwiper: null,
    mySwiper_about: null,
    mySwiper_product: null,
    navList: [],
    navForm: null,
    allowSlidePrev: false, // swiper 向上
    allowSlideNext: true, // swiper 向下
    player: null, // 首页视频
    aboutForm: null, //关于我们
    productForm: null, //产品和服务
    newsForm: null, //媒体之声
    contactForm: null, //加入我们
    isHomePage: true,
    realIndex:null // 首页轮播图位置
  };
  componentDidMount() {
    // console.log("项目启动");

    this.setState({
      isMobile: judgmentTerminal(),
    });
    setTimeout(() => {
      const swiperPage = window.localStorage.getItem("swiperPage");
      // console.log(swiperPage);
      // console.log(this.state.mySwiper);
      if (swiperPage) {
        this.state.mySwiper.slideTo(swiperPage, 300, false);
        window.localStorage.removeItem("swiperPage");
      }
    }, 100);
  }
  // 跳转页面
  goSlide = () => {
    this.state.mySwiper.slideTo(2, 300, false);
    this.state.mySwiper_about.slideTo(2, 300, false);
  };
  // 将子组件传过来的实例赋值给navForm
  onRef = (ref) => {
    // eslint-disable-next-line
    this.state.navForm = ref;
    // console.log(this.state.navForm);
  };
  // 首页视频播放
  onPlayer = (ref) => {
    this.setState({
      player: ref,
    });
  };
  // 子组件传实例this
  componentRef = (ref, type) => {
    switch (type) {
      case "about":
        this.setState({
          aboutForm: ref,
        });
        break;
      case "product":
        this.setState({
          productForm: ref,
        });
        break;
      case "news":
        this.setState({
          newsForm: ref,
        });
        break;
      case "contact":
        this.setState({
          contactForm: ref,
        });
        break;
      default:
        break;
    }
  };
  // 导航栏
  navIndex = (val) => {
    // console.log("导航栏" + val);
  };
  // 语言切换
  langChange = () => {
    // console.log("语言切换");
    const { i18n } = this.props;
    i18n.changeLanguage(i18n.language === "zh_cn" ? "en" : "zh_cn");
    // this.state.player.load();
    // this.state.mySwiper.disable()
  };
  // 导航栏跳页面
  toPage = (index) => {
    if (index === 5) {
      this.props.history.push("/download");
    } else {
      this.state.mySwiper.slideTo(index, 300, false);
    }
  };
  // 二级页面
  toSecondPage = (page) => [this.props.history.push("/" + page)];
  // 返回首页
  toPageHome = () => {
    this.props.history.push("/");
  };
  // 滑动触发
  slideChange = () => {
    // console.log("mySwiper:" + this.state.mySwiper.realIndex);
    this.setState({
      realIndex:this.state.mySwiper.realIndex
    })
    this.state.mySwiper.realIndex > 0
      ? this.setState({ isHomePage: false })
      : this.setState({ isHomePage: true });
    if (this.state.mySwiper.realIndex === 0) {
      this.setState({
        allowSlidePrev: false,
      });
      this.state.player.load();
    } else {
      this.setState({
        allowSlidePrev: true,
      });
      this.state.player.pause();
    }
    if (this.state.mySwiper.realIndex === 4) {
      this.setState({
        allowSlideNext: false,
      });
    } else {
      this.setState({
        allowSlideNext: true,
      });
    }
    const realIndex = this.state.mySwiper.realIndex;
    // 选择导航换色
    this.state.navForm.setState({
      select_index: this.state.mySwiper.realIndex,
    });
    // 不通背景换导航字体颜色
    switch (realIndex) {
      case 0:
        this.state.navForm.setState({
          background_is_black: true,
        });
        break;
      default:
        this.state.navForm.setState({
          background_is_black: false,
        });
    }
    // 关于我们
    this.slideAbout_Product();
    // 媒体之声
    this.slideNews();
  };
  // 切换到关于我们，产品和服务
  slideAbout_Product() {
    // const mySwiper_about_running =
    //   this.state.aboutForm.state.mySwiper_about.autoplay.running;
    // const mySwiper_product_running =
    //   this.state.productForm.state.mySwiper_product.autoplay.running;
    this.state.aboutForm.state.mySwiper_about.autoplay.stop();
    this.state.productForm.state.mySwiper_product.autoplay.stop();
    if (this.state.mySwiper.realIndex === 1) {
      this.state.aboutForm.state.mySwiper_about.slideTo(0, 0, false); // loop模式前后各复制一张
      // if (!mySwiper_about_running)
      this.state.aboutForm.state.mySwiper_about.autoplay.start();
      // if (mySwiper_product_running)
      this.state.productForm.state.mySwiper_product.autoplay.stop();
      this.state.aboutForm.setState({
        about_1_show: true,
      });
      this.state.productForm.setState({
        product_1_show: false,
      });
    } else if (this.state.mySwiper.realIndex === 2) {
      this.state.productForm.state.mySwiper_product.slideTo(0, 0, false);
      // if (mySwiper_about_running)
      this.state.aboutForm.state.mySwiper_about.autoplay.stop();
      // if (!mySwiper_product_running)
      this.state.productForm.state.mySwiper_product.autoplay.start();
      this.state.aboutForm.setState({
        about_1_show: false,
      });
      this.state.productForm.setState({
        product_1_show: true,
      });
    } else {
      // console.log(mySwiper_about_running, mySwiper_product_running);
      // if (mySwiper_about_running)
      this.state.aboutForm.state.mySwiper_about.autoplay.stop();
      // if (mySwiper_product_running)
      this.state.productForm.state.mySwiper_product.autoplay.stop();
      this.state.aboutForm.setState({
        about_1_show: false,
      });
      this.state.productForm.setState({
        product_1_show: false,
      });
    }
  }
  // 切换到媒体之声
  slideNews() {
    if (this.state.mySwiper.realIndex === 3) {
      this.state.newsForm.setState({
        news_show: true,
      });
      this.state.productForm.setState({
        product_1_show: false,
      });
      this.state.contactForm.setState({
        contact_show: false,
      });
    } else if (this.state.mySwiper.realIndex === 4) {
      this.state.contactForm.setState({
        contact_show: true,
      });
      this.state.newsForm.setState({
        news_show: false,
      });
    } else {
      this.state.newsForm.setState({
        news_show: false,
      });
      this.state.contactForm.setState({
        contact_show: false,
      });
    }
  }
  // 创建swiper并赋值 start
  setSwiper = (el) => {
    this.setState({
      mySwiper: el,
    });
    if (el.realIndex === 0) {
      this.setState({
        allowSlidePrev: false,
      });
    } else {
      this.setState({
        allowSlidePrev: true,
      });
    }
  };
  // 创建swiper并赋值 end
  render() {
    const { t, i18n } = this.props;
    const { allowSlidePrev, allowSlideNext, isHomePage,realIndex } = this.state;
    // const navList = JSON.parse(t("navList"));
    return (
      <div className="container">
        {/* 导航栏 */}
        <Nav
          onRef={this.onRef}
          navIndex={this.navIndex}
          langChange={this.langChange}
          toPageSwiper={this.toPage}
          logoClick={this.toPageHome}
          toSecondPage={this.toSecondPage}
          navList={t("navList")}
          navListLevel={t("navListLevel")}
          lang={i18n.language}
          isHomePage={isHomePage}
        />
        <Swiper
          direction={"vertical"}
          modules={[Virtual]}
          mousewheel={true}
          keyboard={true}
          allowSlidePrev={allowSlidePrev}
          allowSlideNext={allowSlideNext}
          initialSlide={0}
          onSlideChange={this.slideChange}
          onSwiper={this.setSwiper}
        >
          <SwiperSlide>
            <Player
              ref={this.onPlayer}
              fluid={true}
              muted={true}
              autoPlay={true}
              loop={true}
              src={require("../../assets/video/logo.MP4").default}
            >
              <ControlBar
                autoHide={false}
                disableDefaultControls={true}
              ></ControlBar>
            </Player>
            {/* <img
              src={require("@/assets/images/home_logo.gif").default}
              alt=""
            /> */}
          </SwiperSlide>
          <SwiperSlide>
            {/* 关于我么 */}
            <About
              componentRef={this.componentRef}
              about_content={t("about")}
              about_2_list={t("about_2")}
              about_3_list={t("about_3")}
            />
          </SwiperSlide>
          <SwiperSlide>
            {/* 产品&服务 */}
            <Product
              componentRef={this.componentRef}
              product_content={t("product")}
              toSecondPage={this.toSecondPage}
            />
          </SwiperSlide>
          <SwiperSlide>
            {/* 媒体之声 */}
            <News
              componentRef={this.componentRef}
              news_content={t("news")}
              news_list={t("news_list")}
              realIndex={realIndex}
            />
          </SwiperSlide>
          <SwiperSlide>
            {/* 加入我们 */}
            <Contact
              componentRef={this.componentRef}
              contact_content={t("contact")}
              recruit={t("recruit")}
              contact_cooperation={t("contact_cooperation")}
              wechat_tips={t("wechat_tips")}
              lang={i18n.language}
            />
          </SwiperSlide>
        </Swiper>
      </div>
    );
  }
}

export const Home = withTranslation()(HomeComponent); // 使用withTranslation高阶函数来完成语言配置的数据注入
